<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Contact Details</h1>
    <p>Please provide the contact details for the new client.</p>
    <p>As we will be handling the onboarding on your behalf, we'll require the onboarding point of contact at the organisation.</p>
  </div>

  <div class="cell small-6">
    <form class="fieldset" @submit.prevent>

      <!-- Show ONLY when not onboarding via intermediary -->
      <template v-if="showOnboardingContactFields">
        <label>First Name</label>
        <input
          type="text"
          id="contactFirstName"
          name="contactFirstName"
          placeholder=""
          v-model="formData.invitee.firstName"
          maxlength="35"
          required
        />

        <label>Surname</label>
        <input
          type="text"
          id="contactSurname"
          name="contactSurname"
          placeholder=""
          v-model="formData.invitee.lastName"
          maxlength="35"
          required
        />

        <label>Email Address</label>
        <input
          type="text"
          id="contactEmail"
          name="contactEmail"
          placeholder=""
          v-model="formData.invitee.email"
          maxlength="35"
          required
        />
      </template>
    </form>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const error = ref([])

const props = defineProps({
  formData: Object
})

// Your rule (as written):
// validate + show First/Surname/Email ONLY if isOnboardingViaIntermediary == false
const showOnboardingContactFields = computed(() => props.formData?.isOnboardingViaIntermediary === false)

const isBlank = (v) => String(v ?? '').trim().length === 0

const isValidEmail = (email) => {
  const e = String(email ?? '').trim()
  // simple + solid email regex for typical validation
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
}

const validateStep = () => {
  error.value = []

  // Only validate these if onboarding via intermediary == false
  if (showOnboardingContactFields.value) {
    if (isBlank(props.formData?.invitee?.firstName)) {
      error.value.push('First Name is required.')
    }
    if (isBlank(props.formData?.invitee?.lastName)) {
      error.value.push('Surname is required.')
    }
    if (isBlank(props.formData?.invitee?.email)) {
      error.value.push('Email Address is required.')
    } else if (!isValidEmail(props.formData?.invitee?.email)) {
      error.value.push('Email Address must be a valid email address.')
    }
  }

  return error.value.length === 0
}

const executeStep = async () => true

defineExpose({ validateStep, executeStep })
</script>
